import { render, staticRenderFns } from "./UsersRolesView.vue?vue&type=template&id=7c5aac88"
import script from "./UsersRolesView.vue?vue&type=script&lang=js"
export * from "./UsersRolesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports